var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversationBubbles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6168_5258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.06356 7.48603C4.02212 7.21898 4.00063 6.9454 4.00063 6.66683C4.00063 3.72131 6.40415 1.3335 9.36905 1.3335C12.3339 1.3335 14.7375 3.72131 14.7375 6.66683C14.7375 7.33221 14.6148 7.96913 14.3908 8.5565C14.3442 8.67849 14.321 8.73948 14.3104 8.7871C14.2999 8.83429 14.2959 8.86748 14.2947 8.9158C14.2936 8.96456 14.3002 9.01828 14.3134 9.12571L14.5818 11.3058C14.6109 11.5419 14.6254 11.6599 14.5861 11.7456C14.5517 11.8208 14.4906 11.8805 14.4147 11.9132C14.328 11.9504 14.2104 11.9332 13.9751 11.8987L11.8516 11.5874C11.7408 11.5712 11.6853 11.5631 11.6348 11.5633C11.5849 11.5636 11.5503 11.5673 11.5014 11.5776C11.452 11.588 11.3889 11.6116 11.2626 11.6589C10.6738 11.8795 10.0356 12.0002 9.36905 12.0002C9.09025 12.0002 8.81643 11.979 8.54909 11.9383M5.08837 14.6668C7.06497 14.6668 8.66732 13.0252 8.66732 11.0002C8.66732 8.97512 7.06497 7.3335 5.08837 7.3335C3.11177 7.3335 1.50942 8.97512 1.50942 11.0002C1.50942 11.4072 1.57417 11.7988 1.69368 12.1646C1.7442 12.3193 1.76947 12.3966 1.77776 12.4495C1.78641 12.5046 1.78793 12.5356 1.7847 12.5913C1.78162 12.6447 1.76826 12.705 1.74155 12.8257L1.33398 14.6668L3.33052 14.3942C3.43949 14.3793 3.49398 14.3718 3.54156 14.3722C3.59166 14.3725 3.61826 14.3752 3.66739 14.385C3.71405 14.3943 3.78342 14.4188 3.92216 14.4678C4.28771 14.5968 4.68006 14.6668 5.08837 14.6668Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6168_5258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationBubbles);
export default __webpack_public_path__ + "static/media/conversation-bubbles.f38f2b41e6ec12f15805f0dee4637d9d.svg";
export { ForwardRef as ReactComponent };